export default "__VITE_ASSET__zvn4ySLRE4XjdOqFahk7IQ__"